import { fileUploadRequest } from '@/api/request';

import {
  GetArchiveRequest,
  UploadArchiveRequest,
  UploadArchiveResult,
} from './Archive.types';

import { API_BASE_URL } from '..';
import api from '@/api';

const CONTROLLER_URL = `${API_BASE_URL}/archive`;

export async function uploadArchive(
  req: UploadArchiveRequest,
): Promise<UploadArchiveResult> {
  const result = (await fileUploadRequest(
    `${CONTROLLER_URL}`,
    req.file as unknown[],
  )) as unknown;

  return result as UploadArchiveResult;
}

export async function getArchive(obj: GetArchiveRequest) {
  const result = (await api.getReport(`${CONTROLLER_URL}/${obj.key}`, {
    subdirectory: obj.subdirectory,
  })) as unknown;

  return result as Blob;
}
